import { computed, Ref, ref } from "@vue/composition-api";

type UseTabsReturn<T> = [
  Readonly<Ref<readonly T[]>>,
  Readonly<Ref<Readonly<T>>>,
  (val: T) => void,
  (tabs: T[], initial_tab: T | number) => void,
  (index: number, val: T) => void
];

export const UseTabs = <T>(
  tabs: T[],
  initial_tab: T | number
): UseTabsReturn<T> => {
  const _current_tab: Ref<T> = ref(
    typeof initial_tab == "number" ? tabs[initial_tab] : initial_tab
  );
  const current_tab = computed(() => _current_tab.value);

  const used_tabs: Ref<T[]> = ref(tabs);
  const displayed_tabs = computed(() => used_tabs.value);

  const change_tab = (val: T) => (_current_tab.value = val);

  const reset_tabs = (tabs: T[], initial_tab: T | number) => {
    used_tabs.value = tabs;
    if (typeof initial_tab == "number") {
      _current_tab.value = tabs[initial_tab];
    } else {
      _current_tab.value = initial_tab;
    }
  };

  const update_tab = (index: number, val: T) => {
    used_tabs.value = used_tabs.value.map((tab, idx) => {
      if (index == idx) {
        return val;
      }
      return tab;
    });
  };
  return [displayed_tabs, current_tab, change_tab, reset_tabs, update_tab];
};
